export const StringUtil = {
    capitalizeFirstLetter: (str) => str.charAt(0).toUpperCase() + str.slice(1),
    
    stringify: (valueToConvert) => '' + valueToConvert,

    hashCode: (str) => {
        let hash = 0;
        if (str.length === 0) return hash;
        for (let i = 0; i < str.length; i++) {
            let code = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + code;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    },

    copyToClipboard: (elem, str) => {
        let textArea = document.createElement("textarea");

        // Place in top-left corner of screen regardless of scroll position.
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;

        // Ensure it has a small width and height. Setting to 1px / 1em
        // doesn't work as this gives a negative w/h on some browsers.
        textArea.style.width = '2em';
        textArea.style.height = '2em';

        // We don't need padding, reducing the size if it does flash render.
        textArea.style.padding = 0;

        // Clean up any borders.
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';

        // Avoid flash of white box if rendered for any reason.
        textArea.style.background = 'transparent';

        textArea.setAttribute("contenteditable", "true");

        textArea.value = str;

        elem.parentNode.appendChild(textArea);
        textArea.focus();
        if(textArea.setSelectionRange) textArea.setSelectionRange(0, textArea.value.length);
        else textArea.select();
        setTimeout(() => textArea.blur(), 0);

        try{
            return document.execCommand('copy');
        }
        catch(ex){
            console.log(ex);
            return false;
        }
        finally{
            elem.parentNode.removeChild(textArea);
        }
    }
};
